module.exports = __webpack_public_path__ + "img/friedchicken.57655ce5.jpg";